/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import type { AnyAdminProject } from '@modules/project-admin-api/types'
import TagsPanel from '@modules/resources-shared-components/Tags/TagsPanel'

const ProjectTagsPanel = ({ project }: { project: AnyAdminProject }) => {
  const tags = project.metadata.tags || {}
  const tagsNormalized = Object.entries(tags).map(([key, value]) => ({
    key,
    value,
  }))

  return <TagsPanel tags={tagsNormalized} hideAddTagsButton={true} />
}

export default ProjectTagsPanel
